import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl} from "@angular/forms";
import {Field} from "../../../../interfaces";

@Component({
    selector: 'app-form-input-color',
    templateUrl: './form-input-color.component.html',
    styleUrls: ['./form-input-color.component.scss'],
    standalone: false
})
export class FormInputColorComponent {

  @Input() control: AbstractControl;

  @Input() field: Field<string>;

}
